// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2QaGz","row":"styles_row__1n-_p"};